<template>
<div>
  <h1>Pipeline Log Editor</h1>
  <label class="vform-label white">taskStatus</label><br />
  <select
      class="form-text form-text-dark"
      v-model="localLastKnownTaskStatus"
  >
    <option v-for="(value, key) in TaskManagerStates" :key="key" :value="key">
      {{ $t('pipeline.' + value) }}
    </option>
  </select>
  <input type="text" class="form-text form-text-dark mt-2"
         v-model="config.startedBy"
         />
  <div class="lighter">Actually initated user: {{ config.user }}</div>
  <div @click="saveState" class="settings-button d-inline-block switched-colors mt-2">{{ $t('save') }}</div>
</div>
</template>

<script>
import {TaskManagerStates} from "@/enum.js";
export default {
  name: "PipelineLogEditor",
  props: {
    entry: {type: Object, required: true},
  },
  data() {
    return {
      TaskManagerStates,
      localLastKnownTaskStatus: ''
    }
  },
  computed: {
    config() {
      return this.entry.config
    },
    lastKnownTaskStatus() {
      return this.config ? this.config.lastKnownTaskStatus : '';
    },
  },
  mounted() {
    this.localLastKnownTaskStatus = this.lastKnownTaskStatus;
  },
  methods: {
    saveState() {
      let configCopy = JSON.parse(JSON.stringify(this.config));
      configCopy.lastKnownTaskStatus = this.localLastKnownTaskStatus;
      this.$store.dispatch('updateVMLog', {
        id: this.entry.id,
        config: configCopy
      }).then(() => {
        this.$store.dispatch('createNotification', {
          text: this.$t('pipeline.vmLogUpdated')
        });
        this.$emit('saved');
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.form-text {
  max-width: 200px;
}
</style>